import React from "react";

/** When true, hybrid grid cells include Q_<grid>_SUBHEADER_<col> in aria-labelledby (matches RowType.Text header row). */
export const HybridGridSubHeaderAriaContext = React.createContext(false);

export function useHybridGridSubHeaderAria(): boolean {
    return React.useContext(HybridGridSubHeaderAriaContext);
}
